import { render, staticRenderFns } from "./ScrollToTopButton.vue?vue&type=template&id=1bcbeded&scoped=true&"
import script from "./ScrollToTopButton.vue?vue&type=script&lang=js&"
export * from "./ScrollToTopButton.vue?vue&type=script&lang=js&"
import style0 from "./ScrollToTopButton.vue?vue&type=style&index=0&id=1bcbeded&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bcbeded",
  null
  
)

export default component.exports